<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<h2 class="h2"><a id="page_ix"></a><a id="frontmatter01"></a>ACKNOWLEDGMENTS</h2>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para">Thanks as always to Rose Hilliard and Rachel Vater, editor and agent supreme. To the team at St. Martin’s who worked tirelessly to make this the best book possible.</p>
<p class="indent-para">Team Seattle, for friendship, trips to the gun range, and zombie-themed parties.</p>
<p class="indent-para">All of my blog readers, who provide endless procrastination on slow days.</p>
<p class="indent-para">Jackie, Sara, and Stacia, who never once rolled their eyes when I complained about my deadlines.</p>
<p class="indent-para">Thanks as always to Agent Heidi Wallace of the ATF for her endless patience and infinite knowledge of firearms and law enforcement procedure.</p>
<p class="indent-para">Most of all, to every single reader of the Nocturne City series, those of you who make Luna and her world much bigger than me.</p>
<p class="indent-para">Thank you all.</p>
<div class="pagebreak">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="image"><a id="page_x"></a><img alt="Image" src="images/map.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?ecd5db56